import { Box, Typography, SvgIcon } from '@mui/material'
import { 
    circleInfoIcon,
  } from '../../components/common/iconPaths'
import { errors } from '../../services/constants'
import custom from '../../styles/mui/szVariables.json'

export default function AuthError({ error }: any) {
    return (
        <Box
            id="errorContainer"
            display={error?"flex":"none"}
            mt={custom.spacing.sm}
            mb={custom.spacing.xxs}
            p={custom.spacing.sm}
            sx={{
                borderRadius: custom.corners4,
                border: 2,
                borderColor: 'error.main',
                backgroundColor: 'rgba(255, 26, 44, 0.05)'
            }}>
            <SvgIcon color='error'
                sx={{ pr: custom.spacing.xxxs }}>
                {circleInfoIcon}
            </SvgIcon>
            <Typography  
                id="errorTitle"
                textAlign="left" 
                variant="szHeading.Bold.xSmall"
                color="error">
                    {errors[error]?.title || errors.generic?.title}
                    <Typography
                        id="errorMessage"
                        color="text.primary"
                        textAlign={"left"}
                        pt={custom.spacing.xxxs} 
                        variant="szBody.Regular.Medium">
                        <br/>{errors[error]?.message || errors.generic?.message}
                    </Typography>
            </Typography>

        </Box>
    )
}